import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

import image1 from "../../../assets/images/image1.png";
import image2 from "../../../assets/images/image2.png";
import image3 from "../../../assets/images/image3.png";

export const WorkOrdersRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod(
      "New Service Request",
      "1",
      "",
      "",
      "/maintenance/work-orders/service-requests/new"
    ),
    RightBarMethod("New Recurring Work Order", "2", "", "", "/maintenance/recurring-work-orders/new"),
    RightBarMethod("New Purchase Order", "3", "", "", ""),
  ]),

  RightBarMethod(
    " REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Work Order", "4", "", "", ""),
      RightBarMethod("Work Order Labor Summary", "5", "", "", ""),
    ]
  ),

  RightBarMethod(
    " HELP TOPICS",
    "t3",
    <i className="fa-solid fa-circle-question"></i>,
    [
      RightBarMethod("Vendor Portal Overview", "6", "", "", "/"),
      RightBarMethod("Work Order Index Overview", "7", "", "", "/"),
    ]
  ),
];

export const venderList = [
  {
    value: "24/7 Realty Inc.",
    label: "24/7 Realty Inc.",
  },
  {
    value: "405 Property Group",
    label: "405 Property Group",
  },
  {
    value: "A New Creation L.L.C.",
    label: "A New Creation L.L.C.",
  },
];

export const propertyUnits = ["test", "test2", "test3", "test4"];

export const statusList = [
  {
    value: "All",
    label: "All",
  },
  {
    value: "Open",
    label: "Open",
  },
  {
    value: "New",
    label: "New",
  },
  {
    value: "New by Appfolio",
    label: "New by Appfolio",
  },
  {
    value: "Assigned",
    label: "Assigned",
  },
  {
    value: "Assigned by Appfolio",
    label: "Assigned by Appfolio",
  },
  {
    value: "Scheduled",
    label: "Scheduled",
  },
  {
    value: "Waiting",
    label: "Waiting",
  },
  {
    value: "Estimate Requested",
    label: "Estimate Requested",
  },
  {
    value: "Estimated",
    label: "Estimated",
  },
  {
    value: "Work Completed",
    label: "Work Completed",
  },
  {
    value: "Completed",
    label: "Completed",
  },
  {
    value: "Completed No Need To Bill",
    label: "Completed No Need To Bill",
  },
  {
    value: "Canceled",
    label: "Canceled",
  },
];

export const assignedToList = [
  {
    value: "Aamir Ali",
    label: "Aamir Ali",
  },
  {
    value: "Seerat Ali",
    label: "Seerat Ali",
  },
  {
    value: "Kashif Ali",
    label: "Kashif Ali",
  },
];

export const tableAllData = [];
for (let i = 1; i < 46; i++) {
  tableAllData.push({
    id: i,
    key: i - 1,
    serviceRequest: (
      <div>
        <a href="?">
          {i * 100} - {i}
        </a>
        <br />
        <span className="serviceRequestStatus">COMPLETED</span>
      </div>
    ),
    Property: (
      <div>
        <span style={{ fontWeight: "bold" }}>{i * 199} lorem ipsum</span>
        <br />
        <span>Stephanie Suazo {i}</span>
      </div>
    ),
    description: `London, Park Lane no. ${i} lorem ipsum description`,
    venderAndAssign: (
      <div>
        <span style={{ color: "gray" }}>Vendor/Assign</span>
        <br />
        <span>Company {i} - XYZ</span>
        <br />
        <span>
          <i
            className="fa fa-user-circle"
            aria-hidden="true"
            style={{ fontSize: "20px" }}
          ></i>{" "}
          Edward {i}
        </span>
      </div>
    ),
    createdAt: (
      <div>
        <span style={{ color: "gray" }}>Created</span>
        <br />
        <span>Dec {i + 1}, 2023</span>
      </div>
    ),
    // children: [
    //   {
    //     key: i + 10,
    //     recentActionLog: "01/21/2023 02:42 AM",
    //     jobDescription: `Email sent to "A New Creation L.L.C." <gcombs71@gmail.com>– Esteban Lezcano${i}`,
    //     FollowUp: "--",
    //     ScheduledStart: "Not Scheduled Yet",
    //   },
    // ],
    serviceRequestNo: "14245",
    descript: "leaking",
    createdOn: "03/01/2023",
    createdBy: "Aamir Khan",
    priority: "Normal",
    permissionToEnter: "No",
    property: {
      property: "test 2",
      propertyUnit: "1800 canyon park circle edmond, OK 73013",
      propertyNotes: "None",
      maintenanceLimit: "None",
      homeWarrantyCompany: "--",
      homeWarrantyExpires: "--",
    },
    owner: {
      owner: "Casa Rentals LLC",
      email: "rhett@integrityokc.com ",
      ownerNotes: "None",
    },
    resident: {
      name: "Aamir Khan",
      phoneNumber: "(572) 568-8519",
      email: "aamiralikhan.ali@gmail.com",
      pets: "None",
    },
    workOrders: [
      {
        id: 1,
        workOrderNumber: "14245-1",
        jobDescription: "leaking",
        ownerApproved: "No",
        estimates: [],
        vendorTrade: "No Trade Assigned",
        vendorInstructions: "--",
        residentAvailability: [
          {
            date: "Friday 04/14/2023",
            time: "10:00pm-2:00am CDT",
          },
          {
            date: "Monday 04/17/2023",
            time: "10:00pm-2:00am CDT",
          },
          {
            date: "Tuesday 04/18/2023",
            time: "10:00pm-2:00am CDT",
          },
        ],
        assignee: "Unassigned",
        labor: [],
        purchaseOrders: [],
        withheldAmountfromOwner: "--",
        invoices: [],
        media: [image1, image2, image3],
        vendor: {
          vendor: "AT&T",
          mobile: "(800) 288-2020",
          email: "att@att.com",
          address: "Carol Stream, IL 60197 ",
        },
      },
      {
        id: 2,
        workOrderNumber: "14245-2",
        jobDescription: "Cleaning",
        ownerApproved: "No",
        estimates: [],
        vendorTrade: "No Trade Assigned",
        vendorInstructions: "--",
        residentAvailability: [
          {
            date: "Friday 04/14/2023",
            time: "10:00pm-2:00am CDT",
          },
          {
            date: "Monday 04/17/2023",
            time: "10:00pm-2:00am CDT",
          },
          {
            date: "Tuesday 04/18/2023",
            time: "10:00pm-2:00am CDT",
          },
        ],
        assignee: "Unassigned",
        labor: [],
        purchaseOrders: [],
        withheldAmountfromOwner: "--",
        invoices: [],
        media: [image1, image2, image3],
        vendor: {
          vendor: "AT&T",
          mobile: "(800) 288-2020",
          email: "att@att.com",
          address: "Carol Stream, IL 60197 ",
        },
      },
    ],
  });
}

export const sortByList = [
  {
    value: "CreatedAt",
    label: "Created At",
  },
  {
    value: "Number",
    label: "Number",
  },
  {
    value: "Status",
    label: "Status",
  },
  {
    value: "VendorName",
    label: "Vendor Name",
  },
  {
    value: "Property",
    label: "Property",
  },
  {
    value: "ScheduledStart",
    label: "Scheduled Start",
  },
  {
    value: "FollowUp",
    label: "Follow Up",
  },
];
